<template>
  <div class="rosa">
    <div
      class="recycle-scroller text-center"
      v-if="_.size(calciatoriRosaNonAssegnati) == 0"
    >
      <div class="navy--text text--darken-2">
        <div class="pa-4">
          <v-icon class="navy--text text--darken-2">man </v-icon>
          <v-icon class="navy--text text--darken-2">man </v-icon>
          <v-icon class="navy--text text--darken-2">man </v-icon>
          <v-icon class="navy--text text--darken-2">man </v-icon>
        </div>
        <div v-if="ruolo_id"> Se non vedi calciatori è
          perchè o già sono stati tutti inseriti nei vari slot oppure non hai
          ancora acquistato nessuno.
        </div>
        <div v-else>Nessun calciatore in rosa</div>
      </div>
    </div>
    <v-list
      class="recycle-scroller"
      v-else
      :class="{ 'nice-scroll': !is_mobile }"
    >
      <calciatore
        v-for="(calciatore, key) in calciatoriRosaNonAssegnati"
        :id="key"
        :cal="calciatore"
        :key="key"
        borderAsRuolo
        showMainStatus
        :ripple="ripple"
        :hideEditRemove="hideEditRemove"
        :hideImages="hideCalciatoriImages"
        :selected="
          onCalciatoreClick ? onCalciatoreClick.bind(null, key) : null
        "
        :remove="removeCalciatore.bind(null, key, id_squadra)"
        :edit="showEditValore.bind(null, id_squadra, calciatore.p, key)"
      ></calciatore>
    </v-list>

    <!-- <RecycleScroller
        v-else
        class="recycle-scroller2"
        :class="{ 'nice-scroll': !is_mobile }"
        :items="Object.values(calciatori_sorted(thisSquadra.calciatori))"
        :item-size="54"
        ref="vscroll-list"
        v-slot="{ calciatore, index }"
      >
        <calciatore
          :id="calciatore.id"
          :cal="calciatore"
          :key="index"
          borderAsRuolo
          :hideImages="hideCalciatoriImages"
          :remove="removeCalciatore.bind(null, calciatore.id, id_squadra)"
          :edit="showEditValore.bind(null, id_squadra, calciatore.p, key)"
        ></calciatore>
      </RecycleScroller> -->
    <!-- </div> -->
  </div>
</template>

<script>
import mixins from "../../js/mixins";
import * as Utils from "../../js/utils";
import Constants from "../../js/constants";
import Vuex from "vuex";
import Calciatore from "./Calciatore";
import { RecycleScroller } from "vue-virtual-scroller";

export default {
  name: "asta-rosa",
  components: {
    Calciatore,
    RecycleScroller,
  },
  mixins: [mixins],
  data() {
    return {};
  },
  props: {
    id_squadra: {
      type: String,
    },
    ruolo_id: {
      type: String,
    },
    escludi_ids: {
      type: Array,
    },
    hideCalciatoriImages: {
      type: Boolean,
    },
    hideEditRemove: {
      type: Boolean,
    },
    ripple: {
      type: Boolean,
    },
    onCalciatoreClick: {
      type: Function,
      default: null,
    },
  },
  mounted() {
    console.log("--> AstaRosa ready.");
  },
  destroyed() {
    console.log("<-- AstaRosa destroyed.");
  },
  methods: {
    showEditValore(id_squadra, prezzo, id_calciatore) {
      this.promptEditCalciatoreAssegnato(
        id_squadra,
        prezzo,
        id_calciatore
      );
    },
    removeCalciatore(id, id_squadra) {
      let prezzo = "";
      if (
        this.asta_squadre[id_squadra] &&
        this.asta_squadre[id_squadra].calciatori &&
        this.asta_squadre[id_squadra].calciatori[id]
      ) {
        prezzo = this.asta_squadre[id_squadra].calciatori[id].p;
      }
      this.promptRemoveCalciatoreAssegnato(id, id_squadra, prezzo);
    },
    calciatori_sorted(calciatori) {
      if (calciatori) {
        var res = Utils.orderKeysBy(
          calciatori,
          [
            (id) => {
              return parseInt(this.calciatori[id].ID_Ruolo);
            },
            // (id) => {
            //   return parseInt(calciatori[id]);
            // },
            (id) => {
              return parseInt(this.calciatori[id].quotazione);
            },
          ],
          ["asc", "desc"]
          // ["asc", "desc", "desc"]
        );
        res = _.mapValues(res, (value, id) => {
          return { ...value, id: id };
        });
        return res;
      }
    },
  },
  computed: {
    thisSquadra() {
      return this.asta_squadre[this.id_squadra];
    },
    calciatoriRosaNonAssegnati() {
      if (!this.thisSquadra.calciatori) {
        return {};
      }
      let output = _.assign({}, this.thisSquadra.calciatori);
      // solo ruolo_id
      if (this.ruolo_id) {
        for (const calciatore_id in output) {
          if (this.calciatori[calciatore_id].ID_Ruolo !== this.ruolo_id) {
            delete output[calciatore_id];
          }
        }
      }

      // escludi quelli già associati nella pianificazione
      for (const index in this.escludi_ids) {
        const calciatore_id = this.escludi_ids[index];
        delete output[calciatore_id];
      }

      return this.calciatori_sorted(output);
    },
  },
};
</script>
<style lang="scss" scoped>
.rosa {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.recycle-scroller {
  flex: 1 1 auto;
  min-height: 0;
}

// .recycle-scroller2 {
//   // background: transparent;
//   // // vale per la dialog
//   // //height: 400px; // importante: deve essere specificato altrimenti reycler-scroller non funzionerà
//   // // e serve anche per far scrollare solo la lista invece che tutta la dialog
//   // // 400px è per la dialog nel mobile
//   // overflow-y: auto;
//   // max-height: 400px;
// }
</style>
